import { Navbar } from "@/components/sections/Navbar";
import { Footer } from "@/components/sections/Footer";
import { Seo } from "@/components/Seo";
import { BlogCard } from "@/components/blog/BlogCard";
import { LotusIcon } from "@/components/ui/lotus-icon";
import { blogPosts } from "@/data/blogPosts";

const BlogPage = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Lunssence Blog",
    description:
      "Artikelen over blauwe lotus, hormonale balans, PMS, overgang en bewuste wellness-rituelen.",
    url: "https://lunssence.com/blog",
    blogPost: blogPosts.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      description: p.description,
      datePublished: p.publishedAt,
      url: `https://lunssence.com/blog/${p.slug}`,
      author: { "@type": "Organization", name: "Lunssence" },
    })),
  };

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Blog — Blauwe Lotus, Hormonale Balans & Wellness Rituelen | Lunssence"
        description="Ontdek artikelen over blauwe lotus thee, hormonale balans, PMS, overgang en dagelijkse wellness-rituelen. Kennis en rust in elk kopje."
        path="/blog"
        jsonLd={jsonLd}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none">
          <LotusIcon size={500} className="text-gold-light" />
        </div>
        <div className="container mx-auto px-4 relative z-10 text-center">
          <p className="uppercase tracking-[0.3em] text-gold text-sm font-semibold mb-4">
            Lunssence Journal
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-bold text-primary mb-6">
            Blog & Rituelen
          </h1>
          <p className="text-lg md:text-xl text-primary/70 max-w-2xl mx-auto leading-relaxed">
            Kennis, verhalen en rituelen rondom blauwe lotus, hormonale balans en
            bewuste wellness. Voor vrouwen die luisteren naar hun lichaam.
          </p>
        </div>
      </section>

      {/* Posts grid */}
      <section className="pb-24">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <BlogCard key={post.slug} post={post} />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
